if (
  customElements.get('marquee-carousel') &&
  !customElements.get('marquee-social-feed')
) {
  const MarqueeCarousel = customElements.get('marquee-carousel');

  class MarqueeSocialFeed extends MarqueeCarousel {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.querySelector('[data-container]');
      this.itemsContainer = this.querySelector('[data-items]');
      this.stop();
      this.initObserver();
    }

    initObserver() {
      // Options for the observer (which mutations to observe)
      const config = {
        attributes: true,
        childList: true,
        subtree: true,
      };

      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            this.cloneItems();
            break;
          }
        }
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(this.itemsContainer, config);
    }

    destroyObserver() {
      this.observer?.disconnect();
    }

    cloneItems() {
      if (!this.itemsContainer) {
        return;
      }

      const cloneItems = this.itemsContainer.cloneNode(true);
      const instagramFeed = cloneItems.querySelector('[data-intagram-feed]');

      if (!instagramFeed) {
        return;
      }

      instagramFeed.id = `${instagramFeed.getAttribute('id')}-clone`;

      this.container.append(cloneItems);

      this.destroyObserver();

      this.manualLoadImages(cloneItems);

      this.start();
    }

    manualLoadImages(element) {
      element
        .querySelectorAll('img')
        .forEach((image) => (image.src = image.dataset.instafeedSrc));
    }
  }
  customElements.define('marquee-social-feed', MarqueeSocialFeed);
}
